// extracted by mini-css-extract-plugin
module.exports = {"dialogsBox":"style_dialogsBox__2csYY","content":"style_content__1GZUW","menu":"style_menu__3M8e8"};